module.exports = __webpack_public_path__ + "img/10.a3c66830.png";